import { render, staticRenderFns } from "./addBackUser.vue?vue&type=template&id=f2313e66&scoped=true&"
import script from "./addBackUser.vue?vue&type=script&lang=js&"
export * from "./addBackUser.vue?vue&type=script&lang=js&"
import style0 from "./addBackUser.vue?vue&type=style&index=0&id=f2313e66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2313e66",
  null
  
)

export default component.exports